import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';

// Mobile bottom tab bar (R-147). Fixed to the viewport bottom with
// safe-area-inset padding (PWA on notched phones); items are equal-width
// links ≥48px tall (touch target), active = soft-bg highlight (no accent
// bar — the sidebar rule carries over).
export const styles = {
  nav: {
    kVAEAm: "xixxii4",
    kkqhue: "x17y0mx6",
    krVfgx: "x1ey2m1c",
    kY2c9j: "x6y048q",
    k1xSpc: "xrvj5dj",
    kprqdN: "x1mt1orb",
    klIVar: "xu6a5m6",
    kOIVth: "x1jnr06f",
    kg3NbH: "xdqyycr",
    kLKAdn: "x1yrsyyn",
    kGO01o: "x1ch1h7i",
    kWkggS: "x1k55akt",
    kEafiO: "x178xt8z",
    kPef9Z: "x13fuv20",
    kLZC3w: "x1p7xzfl",
    $$css: true
  },
  item: {
    kVAEAm: "x1n2onr6",
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kGNEyG: "x6s0dn4",
    kjj79g: "xl56j7k",
    kOIVth: "x195vfkc",
    kAzted: "x1wxaq2x",
    k8WAf4: "x12ulsxz",
    kaIpWk: "xxltkoq",
    kMwMTN: "xitfd3n",
    kybGjl: "x1hl2dhg",
    kMv6JI: "xdv2sak",
    kGuDYH: "x1s31vzs",
    k63SB2: "xomqrzn",
    kb6lSQ: "x16q24ku",
    kWkggS: "xjbqb8w x5lqt2c",
    kI3sdo: "x1a2a7pz xx4dj4q",
    k1ekBW: "xs2xxs2",
    kIyJzY: "xgdialr",
    $$css: true
  },
  itemActive: {
    kMwMTN: "xmge4x3",
    kWkggS: "x1wtxg5f x106t4ra",
    $$css: true
  },
  icon: {
    kzqmXN: "x17z2i9w",
    kZKoxP: "x17rw0jw",
    kmuXW: "x2lah0s",
    $$css: true
  },
  badge: {
    kVAEAm: "x10l6tqk",
    k87sOh: "xs7f9wi",
    kbCHJM: "x19zf7s8",
    k7Eaqz: "x15kz4h8",
    kZKoxP: "xlup9mm",
    kg3NbH: "xfn1xvj",
    k1xSpc: "x3nfvp2",
    kGNEyG: "x6s0dn4",
    kjj79g: "xl56j7k",
    kaIpWk: "xoy5co8",
    kWkggS: "xlvhwkj",
    kMwMTN: "x1m3rtoy",
    kGuDYH: "x1k6wstc",
    k63SB2: "xomqrzn",
    kLWn49: "xo5v014",
    $$css: true
  }
};